/** Static copy from PCL 25-26 31-08-26.xlsm — sheets J0 / J1 / J_1 / J_2 */

import type {G0Page} from '@/pages/components/audit-program/g-section/constants';

export type JSectionPageCode = 'J0' | 'J1' | 'J_1' | 'J_2';

export const J_SECTION_PAGES: JSectionPageCode[] = ['J0', 'J1', 'J_1', 'J_2'];

export const J_PAGE_TITLES: Record<JSectionPageCode, string> = {
    J0: 'Audit programme - Trade & other receivables',
    J1: 'Deposit paid and prepayment',
    J_1: 'Trade receivable',
    J_2: 'Prepayment',
};

export type JProgrammePage = G0Page;

export const J0_PAGE: JProgrammePage = {
    title: 'AUDIT PROGRAMME - TRADE & OTHER RECEIVABLES',
    rows: [
        {id: 'r1', kind: 'section', num: '', text: 'General', level: 0},
        {id: 'r2', kind: 'main', num: '1', text: 'Obtain and check, or prepare, a lead schedule for the current year\'s figures and reconcile this to the general ledger.', level: 0},
        {id: 'r3', kind: 'main', num: '2', text: 'Carry out analytical procedures such as:', level: 0},
        {id: 'r4', kind: 'sub', num: '(a)', text: 'comparison of the current figures with those of prior periods;', level: 1},
        {id: 'r5', kind: 'sub', num: '(b)', text: 'review and comparison of key ratios or other performance indicators;', level: 1},
        {id: 'r6', kind: 'sub', num: '(c)', text: 'comparison of the top 10 customers this year with last year.', level: 1},
        {id: 'r7', kind: 'main', num: '3', text: 'Review for items above performance materiality or that are otherwise unusual and verify.', level: 0},
        {id: 'r8', kind: 'section', num: '', text: 'Cost/existence', level: 0},
        {id: 'r9', kind: 'main', num: '4', text: 'Obtain or prepare an aged list of balances and test the casts.', level: 0},
        {id: 'r10', kind: 'main', num: '5', text: 'Agree the aged list of balances to the control account.  Obtain explanations for all material adjustments to the control account.', level: 0},
        {id: 'r11', kind: 'main', num: '6', text: 'Perform a circularisation of trade receivables. Ensuring that control of the process is maintained:', level: 0},
        {id: 'r12', kind: 'sub', num: '(a)', text: 'Select a sample of accounts for confirmation from a complete list of balances.  Record the details on a working paper.', level: 1},
        {id: 'r13', kind: 'sub', num: '(b)', text: 'Confirm with client the receivables you wish to circularise.', level: 1},
        {id: 'r14', kind: 'sub', num: '(c)', text: 'Obtain explanations where the client does not want you to circularise particular balances and consider alternative procedures that can be applied.', level: 1},
        {id: 'r15', kind: 'sub', num: '(d)', text: 'Consider whether the refusal to allow circularisation of particular balances will impose a limitation of scope on the audit or is an indication of fraud.', level: 1},
        {id: 'r16', kind: 'sub', num: '(e)', text: 'Send the confirmation requests.  Enclose a prepaid envelope for return to the firm.  Ensure the reply part of the letter is properly referenced.', level: 1},
        {id: 'r17', kind: 'sub', num: '(f)', text: 'In respect of each reply:', level: 1},
        {id: 'r18', kind: 'sub', num: '(i)', text: 'record it on the control sheet;', level: 2},
        {id: 'r19', kind: 'sub', num: '(ii)', text: 'agree or reconcile the balance to that shown in the client\'s records;', level: 2},
        {id: 'r20', kind: 'sub', num: '(iii)', text: 'investigate any exceptions;', level: 2},
        {id: 'r21', kind: 'sub', num: '(iv)', text: 'consider whether any of the exceptions are indicative of fraud or other misstatement.', level: 2},
        {id: 'r22', kind: 'sub', num: '(g)', text: 'Where replies are not received within a reasonable period send a follow-up letter.', level: 1},
        {id: 'r23', kind: 'sub', num: '(h)', text: 'Perform the alternative procedures for any unfavourable responses or where no response obtained.', level: 1},
        {id: 'r24', kind: 'sub', num: '(i)', text: 'Summarise the results and consider whether adequate audit comfort has been obtained for trade debtors.', level: 1},
        {id: 'r25', kind: 'main', num: '7', text: 'Where circularisation has not been carried out select a sample of trade receivables or where unsatisfactory results are obtained carry out alternative procedures.', level: 0},
        {id: 'r26', kind: 'sub', num: '(a)', text: 'Examine the ledger for subsequent settlement.', level: 1},
        {id: 'r27', kind: 'sub', num: '(b)', text: 'For unpaid items inspect proof of delivery or despatch.  If no such documentation is available, inspect the sales invoice supporting them.', level: 1},
        {id: 'r28', kind: 'sub', num: '(c)', text: 'Review correspondence files for items in (b) to determine whether any disputes exist.', level: 1},
        {id: 'r29', kind: 'sub', num: '(d)', text: 'Consider requesting a transaction history from key customers.', level: 1},
        {id: 'r30', kind: 'main', num: '8', text: 'List all credit balances over HK$_________  and obtain explanations.', level: 0},
        {id: 'r31', kind: 'section', num: '', text: 'Valuation', level: 0},
        {id: 'r32', kind: 'main', num: '9', text: 'Review ledger accounts and obtain a list of any debts with balances:', level: 0},
        {id: 'r33', kind: 'sub', num: '(a)', text: 'not paid within ________ months of the period end;', level: 1},
        {id: 'r34', kind: 'sub', num: '(b)', text: 'in excess of their credit limit;', level: 1},
        {id: 'r35', kind: 'sub', num: '(c)', text: 'in the hands of liquidators or receivers;', level: 1},
        {id: 'r36', kind: 'sub', num: '(d)', text: 'in the hands of lawyers for collection.', level: 1},
        {id: 'r37', kind: 'main', num: '10', text: 'Compare the client\'s allowance for uncollectibility for trade receivables with the list completed above and consider its adequacy.  Obtain explanations for and justify any material accounts omitted from the client\'s list.', level: 0},
        {id: 'r38', kind: 'section', num: '', text: 'Cut-off', level: 0},
        {id: 'r39', kind: 'main', num: '11', text: 'Cut-off testing is covered in Section R.', level: 0},
        {id: 'r40', kind: 'section', num: '', text: 'Prepayments', level: 0},
        {id: 'r41', kind: 'main', num: '12', text: 'Obtain a list of items included as prepayments:', level: 0},
        {id: 'r42', kind: 'sub', num: '(a)', text: 'Test mathematical accuracy.', level: 1},
        {id: 'r43', kind: 'sub', num: '(b)', text: 'Vouch material items to bank statements and invoices.', level: 1},
        {id: 'r44', kind: 'sub', num: '(c)', text: 'Review for reasonableness and verify significant/unusual items, comparing with last year and expectations.', level: 1},
        {id: 'r45', kind: 'section', num: '', text: 'Other receivables', level: 0},
        {id: 'r46', kind: 'main', num: '13', text: 'Obtain or prepare a list of other receivables.', level: 0},
        {id: 'r47', kind: 'sub', num: '(a)', text: 'Vouch material items to supporting documentation.', level: 1},
        {id: 'r48', kind: 'sub', num: '(b)', text: 'Compare with previous year and enquire into major differences.', level: 1},
        {id: 'r49', kind: 'section', num: '', text: 'Loans', level: 0},
        {id: 'r50', kind: 'main', num: '14', text: 'Ensure that no loans have been made to directors unless within the provisions of applicable legislation.', level: 0},
        {id: 'r51', kind: 'section', num: '', text: 'Long-term receivables', level: 0},
        {id: 'r52', kind: 'main', num: '15', text: 'Where a receivable, or portion thereof is recoverable after more than one year, consider:', level: 0},
        {id: 'r53', kind: 'sub', num: '(a)', text: 'whether any allowance for impairment and / or uncollectibility is necessary.', level: 1},
        {id: 'r54', kind: 'sub', num: '(b)', text: 'whether adequate disclosure has been made.', level: 1},
        {id: 'r55', kind: 'sub', num: '(c)', text: 'whether the receivable is properly accounted for unless the fair value effect is immaterial.', level: 1},
        {id: 'r56', kind: 'section', num: '', text: 'Presentation and disclosure', level: 0},
        {id: 'r57', kind: 'main', num: '16', text: 'Ensure that there is sufficient appropriate evidence on the file to support the disclosures made.', level: 0},
        {id: 'r58', kind: 'main', num: '17', text: 'Review transactions and balances with directors and ensure they are properly presented as related party transactions.', level: 0},
        {id: 'r59', kind: 'main', num: '18', text: 'Where a director\'s loan account is overdrawn ensure that the necessary disclosures are made.', level: 0},
        {id: 'r60', kind: 'main', num: '19', text: 'Ensure that any factored debts have been accounted for in accordance with the substance of the agreement.', level: 0},
        {id: 'r61', kind: 'section', num: '', text: 'Bespoke tests', level: 0},
        {id: 'r62', kind: 'main', num: '20', text: 'Draft and perform any necessary additional tests such as those required by C8.3 and cross reference with the objectives on the summary sheet.', level: 0},
        {id: 'r63', kind: 'section', num: '', text: 'Conclusion', level: 0},
        {id: 'r64', kind: 'main', num: '21', text: 'Consider whether there are any points which need to be included in a letter of representation or letter of comment and record on A5 or A6, as appropriate.', level: 0},
        {id: 'r65', kind: 'main', num: '22', text: 'Review the planned extent of reliance on internal controls in this area and consider whether this remains appropriate.', level: 0},
        {id: 'r66', kind: 'main', num: '23', text: 'Assess whether the initial materiality and/or risk assessment should be revised in view of the audit evidence obtained.  Record details of any necessary adjustments on B6 or B9.  Consider the impact on the remainder of the audit work and on any work undertaken to date.', level: 0},
    ],
};

export type JRemark = {tick: string; text: string};

export type JSummaryLine = {
    id: string;
    label: string;
};

export type J1Page = {
    title: string;
    subtitle?: string;
    cyLabel: string;
    lyLabel: string;
    summaryLines: JSummaryLine[];
    conclusionLabel: string;
    conclusionPlaceholder: string;
    remarksTitle: string;
    remarks: JRemark[];
    blankBreakdownRows: number;
};

export type JBreakdownPage = {
    title: string;
    subtitle?: string;
    amountLabel: string;
    breakdownTitle: string;
    cyLabel: string;
    lyLabel: string;
    conclusionLabel: string;
    conclusionPlaceholder: string;
    remarksTitle: string;
    remarks: JRemark[];
    blankBreakdownRows: number;
};

const COMMON_REMARKS: JRemark[] = [
    {tick: 'V', text: 'Checked to invoices'},
    {tick: 'b', text: "Per last year's working paper"},
    {tick: '>', text: 'Per ledger'},
    {tick: '^', text: 'Casting checked'},
    {tick: 's/s', text: 'subsequent settlement checked'},
    {tick: 'C/CC', text: 'Confirmation sent/received'},
];

export const J1_PAGE: J1Page = {
    title: 'Deposit paid and prepayment',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    summaryLines: [
        {id: 'deposit', label: 'Deposit'},
        {id: 'prepayment', label: 'Prepayment'},
    ],
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'All deposits and prepayment are exist and accurate',
    remarksTitle: 'Remark',
    remarks: [
        {tick: 'V', text: 'Checked to the agreement and payment record'},
        {tick: 'V', text: 'Checked to invoices'},
        {tick: 'b', text: "Per last year's working paper"},
        {tick: '>', text: 'Per ledger'},
        {tick: '^', text: 'Casting checked'},
        {tick: 's/s', text: 'subsequent settlement checked'},
        {tick: 'C/CC', text: 'Confirmation sent/received'},
    ],
    blankBreakdownRows: 0,
};

export const J_1_PAGE: JBreakdownPage = {
    title: 'Trade receivable',
    subtitle: 'Receivable (Trade + other)',
    amountLabel: 'Trade receivable',
    breakdownTitle: 'Breakdown of the Trade receivable paid',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: COMMON_REMARKS,
    blankBreakdownRows: 8,
};

export const J_2_PAGE: JBreakdownPage = {
    title: 'Prepayment',
    subtitle: 'Assets',
    amountLabel: 'Prepayment',
    breakdownTitle: 'Breakdown of the prepayment paid',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: [
        {tick: 'V', text: 'Checked to invoices'},
        {tick: 'b', text: "Per last year's working paper"},
        {tick: '>', text: 'Per ledger'},
        {tick: '^', text: 'Casting checked'},
    ],
    blankBreakdownRows: 8,
};
